import React from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

/**
 * Function to present the details of pricing plans
 * @param {*} props
 * @returns
 */
function PeriodForm(props) {
  const {
    rowData
  } = props;


  return (
    <form id="periodForm">
      <Grid container spacing={3}>
        <Grid item xs={12}>

          <Table>
            <TableBody>
              <TableRow >
                <TableCell padding="default" >Nombre:</TableCell>
                <TableCell align="center">{rowData[1]}</TableCell>
              </TableRow>

              <TableRow >
                <TableCell padding="default" >Fecha de inicio:</TableCell>
                <TableCell align="center">{rowData[2]}</TableCell>
              </TableRow>

              <TableRow >
                <TableCell padding="default" >Fecha fin:</TableCell>
                <TableCell align="center">{rowData[3]}</TableCell>
              </TableRow>

              <TableRow >
                <TableCell padding="default" >Año escolar:</TableCell>
                <TableCell align="center">{rowData[4]}</TableCell>
              </TableRow>

              <TableRow >
                <TableCell padding="default" >Estado:</TableCell>
                <TableCell align="center">{rowData[6]}</TableCell>
              </TableRow>

            </TableBody>
          </Table>

        </Grid>


      </Grid>
    </form>
  );
}

PeriodForm.propTypes = {
  rowData: PropTypes.array.isRequired
};

export default PeriodForm;
